export default {
  login: {
    email: "e-mail адрес (почта)",
    password: "пароль",
    login: "вход",
    forgot: "забыл пароль"
  },
  app: {
    hello: "Здравствуйте ! (Доброго времени суток!)",
    hello_description: `Ученые показали, что настроение и сон могут влиять на когнитивные способности. Запишите эти данные, чтобы вы могли следить за своими тенденциями.`,
    howareu: "Как у тебя дела, сегодня?",
    sleep: "Сколько часов спал?",
    save: "сохранить",
    five: "5 или ещё меньше.",
    nine: "9 или ещё больше.",
    cokkotu: "очень плохо",
    kotu: "плохо",
    idareeder: "пойдёт",
    good: "Хорошо",
    super: "Отлично!"
  },
  header: {
    tests: "Тесты",
    logout: "выход",
    home: "ГЛАВНЫЙ ЭКРАН",
    education: "ОБУЧЕНИЯ",
    exercises: "РАЗМИНКИ"
  },
  pause: {
    paused: "стоп",
    continue: "нажмите для продолжения"
  },
  coursedetail: {
    step: "разминка",
    second: "сек.",
    start: "НАЧАТЬ",
    confirm:
      "Разминка ещё не закончилась, если выйдите ваши данные не сохраняться.",
    done: "Разминки на сегодня завершены."
  },
  courses: {
    courses: "Курсы",
    description: `С помощью этих упражнений, специально разработанных для вас, вы приобретёте; <br />
    - Разминку глазных мышц<br />
    - Улучшение зрения <br />
    - Расширение поле зрения<br />
    - Улучшение скорости глаз при чтении строк<br />
    Таким образом, вы будете читать быстрее, обеспечив гармонию зрения + восприятия прочитанного текста`,
    total_day: "Общая продолжительность курса:",
    finished_day: "{day} завершено",
    day: "День",
    canrepeat: "Дни повторений {day} Остаток упражнений {exercise}",
    repeat: "Повторить",
    repeat_step: "{step}. день/дней",
    start_repeat: "Начать сначала",
    continue_repeat: "Продолжить снова",
    start: "НАЧАТЬ"
  },
  edetail: {
    start: "НАЧАТЬ"
  },
  e: {
    welcome: "Добро пожаловать на разминку!",
    description: `Вы можете начать с выбора любого типа упражнений, которые вам нужны для развития скорочтения.`
  },
  cats: {
    "Göz Egzersizleri": "Разминка для глаз",
    "Dikkat & Odaklanma": "Внимание и фокус",
    Hız: "Скорость",
    Hafıza: "Память",
    "Okuma & Anlama": "Чтение и понимание",
    test: "Тест на скорость чтения",
    "Zihinsel Matematik": "Устная математика"
  },
  module: {
    start: "НАЧАТЬ",
    speed: "СКОРОСТЬ",
    object_count: "КОЛИЧЕСТВО ПРЕДМЕТОВ",
    eksen: "НАПРАВЛЕНИЕ",
    direction: "НАПРАВЛЕНИЕ",
    horizontal: "горизонт.",
    vertical: "вертикаль.",
    autolevel: "АВТО УВЕЛИЧЕНИЕ",
    yes: "ДА",
    no: "НЕТ",
    time: "ВРЕМЯ",
    level: "УРОВЕНЬ",
    rows: "СТРОКА",
    cols: "СТОЛБЕЦ",
    benzerkelimeler: {
      description: "Отметьте блоки с разными словами"
    },
    read_speed: "Скорость чтения:",
    wordperminute: "Слов/ Минута",
    start_again: "Продолжить снова, продолжить с начала",
    charlevel: "Количество символов",
    screenwidth: "ШИРИНА ЭКРАНА",
    screenheight: "ВЫСОТА ЭКРАНА",
    short: "КОРОТКАЯ",
    mid: "СРЕДНЯЯ",
    long: "ДЛИННАЯ",
    cevrefokus: {
      description: "Запишите слово/слова, которые вы видите на экране."
    },
    group: "Разные",
    same: "ОДИНАКОВЫЕ И РАЗНЫЕ",
    mode: "Позиция",
    isgroup: "Одинаковая<br>категория",
    issame: "ОДИНАКОВЫЕ",
    isnotgroup: "Разная<br>категория",
    isnotsame: "РАЗНЫЕ",
    level_completed: "Глава завершена",
    point: "Твоя оценка:",
    continue: "Продолжить",
    show_time: "ВРЕМЯ ПОКАЗА",
    farkliolan: {
      description: "Отметьте буквы/число, которые отличаются"
    },
    showing_word: "ВЫДЕЛЕННОЕ СЛОВО",
    marquee: "ПРОКРУТКА ТЕКСТА",
    start_again: "Начать снова",
    read_speed: "Скорость чтения: {speed} cлов/минут",
    attention: "ВНИМАНИЕ !",
    open: "ОТКРЫТО",
    close: "ЗАКРЫТО",
    image: "РИСУНОК",
    gozesnetme: {
      description: `вам нужно посчитать, сколько раз указанная выше фигура<br />появляется в течение {seconds} сек.<br /><br />`,
      question: `<br />
      Сколько раз вы увидели вышеуказанную фигуру. <br /><br />`
    },
    grupokuma: {
      level: "количество открывающихся слов: {level}",
      marquee: "Показать только одну строку"
    },
    finished: "КОНЕЦ, ФИНИШ",
    hafiza: {
      des1: "Запомните цветные квадраты",
      des2: "Отметьте квадраты"
    },
    point: "Счёт",
    level: "Уровень",
    total_true: "Правильные ответы: ",
    total_false: "Не правильные ответы: ",
    isabet: "Частота попаданий",
    reaction: "Cкорость реакции на вопрос",
    seconds: "секунд",
    start_again: "Начать заново",
    hafizandatut: {
      desc: "Одинаковая ли карточка на экране и предыдущая ?"
    },
    time: "Время",
    different: "Разные",
    same: "Одинаковые",
    which_bigger: "Какая из них больше?",
    timeisend: "Время вышло,<br>Оценка: {point}",
    left: "Левая",
    allsame: "Оба одинаковые",
    right: "Справа",
    view_time: "Время показа",
    letter_count: "Количество букв",
    harfsayma: {
      description: `Сколько {currentLetter} есть?`
    },
    hizlisecim: {
      description:
        "Форма и цвет на экране такие же, как предыдущая форма и цвет?",
      different: "разные",
      same: "одинаковые"
    },
    text_length: "ДЛИНА ТЕКСТА",
    kelimeavi: {
      description: 'Найдите слово/слова "{currentLetter}" в прочитанном тексте'
    },
    siralama: {
      desc: `Расширьте поле зрения и постройте самую высокую башню.
      Нажмите числа, которые появятся  на экране в порядке от меньшего к большему.`,
      start: "Понятно, можем начинать!",
      starat: "Понятно, можем начинать!"
    },
    tak: {
      placeholder: "Запишите слово/слова, которые вы видите на экране."
    },
    zikzak: {
      desc: `Cколько раз вышеуказанный цвет появляется в течение {seconds} сек.`,
      dikkat: `<br />
      Сколько раз вы увидели вышеуказанную фигуру. <br /><br />`
    }
  },
  home: {
    exercises: "Мои упражнения",
    welcome: "Добро пожаловать!",
    stats: "Статистика скорости чтения",
    last_speed: "Последняя скорость чтения",
    last_under: "Последняя скорость понимания",
    first_speed: "Начальный уровень понимания",
    first_under: "Конечный уровень понимания",
    gain: "Скорость развития",
    read: {
      title: "Прежде чем мы начнем, нам нужно измерить скорость чтения»,",
      desc: `Просим вас прочитать короткий текст и ответить на короткие вопросы о тексте, который вы прочитали. Этот тест поможет нам определить вашу скорость чтения.`,
      start: "Начать тест"
    },
    kdk: " cлово/мин.",
    reading_speed: "Скорость чтения",
    unders: "Уровень понимания"
  },
  modules: {
    "Göz Kasları Esnetme": "Разминка для глазных мышц",
    "İkili & Üçlü Kolon": "Двойная и тройная колонна",
    "Görme Alanı": "Поле зрения",
    "Göz Ritmi": "Ритм глаз",
    "Sıralı Nesneler": "Упорядоченные объекты",
    "Say Bakalım": "Давай посчитаем",
    "Farkı Bul": "Найди отличия",
    "Kelime Avı": "Найди слово",
    Takistoskop: "Тахистоскоп",
    "Çoklu Odak": "Мульти Фокус",
    "Çevre Fokus": "Панорамный фокус",
    "Blok Okuma": "целостное чтение",
    Gölgeleme: "Затенение",
    Gruplama: "Сгруппировать",
    ZikZak: "Упражнение зикзак",
    "Geniş Bakış": "Расширение переферического зрения",
    "Düzelt Bakalım": "Давай исправим",
    "Kelime Yeterliliği": "Словарный запас",
    "Benzer Kelimeler": "Похожие слова",
    "Hangisi Büyük?": "Какой из них большой?",
    Video: "Видео",
    "Hızlı Seçim": "Быстро найди",
    "Köstebeği Yakala": "Поймай крота",
    "Hız Üçgeni": "Треугольник скорости",
    "Hafıza Kareleri": "Запомни квадраты",
    "Dönen Hafıza": "Вращающиеся квадраты",
    "Kare Okuma": "Чтение пирамида (Ромб)",
    "İleri Seviye Kare Okuma": "Чтение пирамида ( расширенное чтение) ",
    Tekerleme: "Скороговорки",
    "Şiir Okuma": "Чтение стихов",
    "Haydi Düzeltelim": "Давай исправим !",
    "İleri Seviye Tekerleme": "Продвинутое чтение скороговорок",
    "İleri Seviye Şiir Okuma": "Продвинутое чтение стихов",
    Heceleme: "Чтение по слогам",
    "Serbest Okuma": "Свободное чтение",
    "Kelime Egzersizi": "Словарный запас"
  },
  speedtest: {
    title: "Добро пожаловать на тест скорости",
    description:
      "Как только вы нажмете кнопку ниже, время начнется. Если вы готовы, давайте начнем!",
    start: "Начать",
    speed: "Ваша скорость чтения",
    kd: "слово/минута",
    time: "Время прохождения {time} секунд",
    desc2:
      "Если вы считаете, что прочитали текст с пониманием, можете переходить к вопросам по тексту.",
    hatirlatma:
      "Мы хотели бы напомнить вам, что если ваш уровень понимания ниже 50%, вам нужно будет повторить это текст.",
    sorularagec: "Перейти к вопросам",
    metnedon: "Назад к тексту",
    hesaplamatamam: "Вычисление завершено",
    anlamaorani: "Ваш уровень понимания",
    geri: "Вернуться",
    hesapla: "Рассчитать",
    bitti: "Завершено"
  },
  golge: {
    mode_1: "Стирающиеся затенения",
    mode_2: "Не стирающиеся, затенения",
    mode_3: "Читаемые затенения",
    mode_4: "Написанные затенения"
  }
};



// WEBPACK FOOTER //
// ./src/languages/ru.js